export default __webpack_public_path__ + "ed135240b426eac2865ef02fd3497878.svg";